import { DateRange } from 'app/shared/services/date-service';
import { KeyValuePair } from '../shared/key-value-pair';
import { CriteriaOperator } from 'app/core/operator';

export class QueryContext {
  segment!: Segment;
  dateRange?: DateRange | {};
  skip?: number;
  take?: number;
  orderBy!: string;
}

export class Segment {
  id!: string;
  type!: StaticSegmentType;
  criterias!: { [key: string]: Criteria };
  name!: string;
  dateRange!: DateRange;
  datePeriod?: DatePeriodType;
}

export class Criteria {
  operator!: CriteriaOperator;
  value: any;
  dateRange?: DateRange;
  frequencyType?: string;
  frequencyValue?: number;
}

export class SegmentResponse {
  id!: string;
  type!: StaticSegmentType;
  criterias!: KeyValuePair<Criteria>[];
  name!: string;
  dateRange!: DateRange;
}

export enum StaticSegmentType {
  MostInteresting = 1,
}

export enum DatePeriodType {
  LastSevenDays = 0,
  LastThirtyDays = 1,
  LastNintyDays = 2,
  Today = 3,
  YesterdayAndToday = 4,
  LastYear = 5,
  LastTwoWeeks = 6,
}
